'use client';

import { Cookie } from 'lucide-react';
import Link from 'next/link';

import { LEGAL_ROUTES } from '@/common/constants';
import { acknowledgeCookies, useCookieAcknowledged } from '@/components/cookie-ack';
import { Button } from '@/components/ui/button';
import { LINK_STYLE } from '@/lib/utils';

export function CookieNotice() {
  const acknowledged = useCookieAcknowledged();
  if (acknowledged) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      // bg-card, not bg-background: it floats over the page, so it has to read as a surface on
      // top of it rather than as a patch of the page with a hairline around it.
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-md rounded-xl border bg-card p-3 shadow-xl motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-4 sm:inset-x-auto sm:bottom-4 sm:left-4 sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div
          aria-hidden
          // bg-background, not bg-muted: in dark --muted and --card are the same value, so a muted
          // plate on this card is invisible.
          className="flex size-9 shrink-0 items-center justify-center rounded-lg border bg-background text-foreground"
        >
          <Cookie size={16} />
        </div>
        <div className="space-y-1">
          <p className="text-base font-semibold text-foreground">We use cookies</p>
          <p className="text-base text-muted-foreground">
            We use cookies and similar technologies to make this site work, understand how it&apos;s
            used, and improve it. See our{' '}
            <Link href={LEGAL_ROUTES.cookieNotice} className={LINK_STYLE}>
              Cookie Notice
            </Link>
            .
          </p>
        </div>
      </div>
      <Button onClick={acknowledgeCookies} size="sm" className="mt-4 w-full">
        I understand
      </Button>
    </div>
  );
}
